import { render, staticRenderFns } from "./TagsView.vue?vue&type=template&id=583969de&scoped=true"
import script from "./TagsView.vue?vue&type=script&lang=js"
export * from "./TagsView.vue?vue&type=script&lang=js"
import style0 from "./TagsView.vue?vue&type=style&index=0&id=583969de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583969de",
  null
  
)

export default component.exports